import DataController from "../DataController";
import Language from "./Language";

export default class SingleLanguageString extends DataController{

    public language: Language;
    public value: string;

    constructor(language: Language, value: string){
        super();
        this.language = language;
        this.value = value;
    }

    public getValue(): string{
        return this.value;
    }

    public getLanguage(){
        return this.language;
    }

    public setValue(value: string){
        this.value = value;
    }

    public setLanguage(language: Language){
        this.language = language;
    }

    public async asDict(){
        return {
            languageId: await this.language.getIdentifier(),
            value: this.value,
        };
    }

    public clone(): SingleLanguageString{
        return new SingleLanguageString(
            this.getLanguage().clone(),
            this.getValue(),
        )
    }

}
